<template>
  <div class="fis-redeem">
    <div class="redeem-header">
      <div class="arrow-icon" @click="back">
        <img src="../assets/arrow-left.png" />
      </div>
      <div class="title">
        Redeem FIS
      </div>
    </div>

    <div class="redeem-content">
   
      <div v-if="warn" class="warn">
        Unable to Unbond, no pool available now. Please wait.
      </div>

      <div class="unbond-title" :class="{'warn-title': warn}">
        1. Unbond FIS
      </div>

      <div class="rfis-balance">
        rFIS balance: {{ totalRFIS }}
      </div>

      <div class="inputs-amount">
        <input type="text" placeholder="RFIS AMOUNT" v-model.trim="tokenAmount"  @keyup="checkAmountInput" />
        <div class="icon">
          <img src="../assets/stafi.png" />
        </div>
      </div>
      
      <div v-if="redeemActiveStatus == 1" class="get-fis">
        You will get {{ returnToken }} FIS
      </div>

      <div class="operation">
        <div class="unbond-btn" :class="{'btn-active': redeemActiveStatus == 1}" @click="unbond">
          Unbond
        </div>
        <div class="unbond-desc">
          Unbond will take 14 days and {{ unbondCommissionShow }} fee
        </div>
      </div>

      <div class="withdraw">

        <div class="unbond-title">
          2. Withdraw unbonded FIS
        </div>

        <div class="withdraw-content">
          <span class="withdraw-token"> {{ withdrawToken }} </span>
          <span class="unbonding-token"> Unbonding: <span class="ubonding-amount">{{ unbondingToken }} ({{ leftDays }} days left) </span> </span>
        </div>

        <div class="withdraw-btn" :class="{'btn-active': withdrawActiveStatus == 1}" @click="withdraw">
          Withdraw
        </div>
      </div>

    </div>
    
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import NumberUtil from '../util/numberUtil.js';
import LocalStorage from '../util/localStorage.js';
import Api from '../util/SubstrateApi.js';
import {
  web3Enable,
  web3FromSource,
} from '@polkadot/extension-dapp';

export default {
  name: 'fisredeem',
  data() {
    return {
      tokenAmount: '',
      totalRFIS: '--',
      warn: false,
      ratio: '',
      unbondCommission: '',
      unbondCommissionShow: '--',
      returnToken: '--',
      redeemActiveStatus: 0,
      clickBtn: false,
      validPools: [],
      unbondings: [],
      withdrawActiveStatus: 0,
      unbondingToken: 0,
      withdrawToken: '0.000',
      currentEra: 0,
      leftDays: '--'
    }
  },
  created() {
    let currentAccount = LocalStorage.getCurrentFisAccount();
    if (currentAccount) {
      Api.createStafiApi().then(api => {

        api.query.staking.currentEra().then(eraData => {
          this.currentEra = eraData.toJSON();
        }).catch((error) => {});

        api.query.rTokenRate.rate(0).then(result => {
          this.ratio = NumberUtil.fisAmountToHuman(result.toJSON());
        });

        api.query.rFis.unbondCommission().then(result => {
          this.unbondCommission = NumberUtil.fisFeeToHuman(result.toJSON());
          this.unbondCommissionShow = NumberUtil.fisFeeToFixed(this.unbondCommission) + '%';
        });

        this.refreshUnbonding();

      });

    } else {
      this.$router.push('/');
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'rfis', params: {source: 'redeem'}});
    },

    validateAmount() {
      if (!this.tokenAmount || this.tokenAmount < 0) {
        this.tokenAmount = '';
        this.returnToken = '--';
        return false;
      }
      if (isNaN(this.tokenAmount)) {
        Toast({ 
          message: 'The deposited amount is invalid', 
          duration: 3000 
        });
        this.tokenAmount = '';
        this.returnToken = '--';
        return false;
      }

      if (Number(this.tokenAmount) > Number(this.totalRFIS)) {
        Toast({ 
          message: 'The input amount should be less than your RFIS balance: ' + this.totalRFIS, 
          duration: 3000 
        });
        this.tokenAmount = '';
        this.returnToken = '--';
        return false;
      }

      return true;
    },

    checkAmountInput() {
      if (this.warn) {
        return;
      }
      if (this.tokenAmount && !isNaN(this.tokenAmount) && this.tokenAmount >= 0) {
        if (Number(this.tokenAmount) > Number(this.totalRFIS)) {
          this.tokenAmount = this.totalRFIS;
        }
        this.redeemActiveStatus = 1;
        if (this.ratio && this.unbondCommission) {
          let returnValue = this.tokenAmount * (1 - this.unbondCommission);
          this.returnToken = NumberUtil.handleFisAmountToFixed(returnValue * this.ratio);;
        }
      } else {
        if (this.tokenAmount != '') {
          Toast({ 
            message: 'The deposited amount is invalid', 
            duration: 3000 
          });
        }
        this.tokenAmount = '';
        this.returnToken = '--';

        this.redeemActiveStatus = 0;
      }
    },

    clearAfterUnbond() {
        this.tokenAmount = '';
        this.returnToken = '--';
        this.redeemActiveStatus = 0;
    },

    unbond() {
      if (this.clickBtn) {
        return;
      }

      this.clickBtn = true;

      if (!this.validateAmount()) {
        this.clickBtn = false;
        this.redeemActiveStatus = 0;
        return;
      }

      if (this.tokenAmount <= 0) {
        Toast({ 
          message: 'The amount should be larger than 0', 
          duration: 3000 
        });
        return;
      }

      if (this.validPools.length <= 0) {
        Toast({ 
          message: 'No pool available, please try again later', 
          duration: 3000 
        });
        return;
      }

      const amount = NumberUtil.fisAmountToChain(this.tokenAmount.toString());
      
      let selectedPool = '';
      this.validPools.some(item => {
        if (item.active >= amount) {
          selectedPool = item.address;
          return true;
        }
      });

      if (!selectedPool) {
        Toast({ 
          message: 'No pool available, please try again later!', 
          duration: 3000 
        });
        return;
      }

      Indicator.open('Loading...');

      web3Enable(Api.getWeb3EnalbeName());
      web3FromSource(Api.getPolkadotJsSource()).then(injector => {

        Api.createStafiApi().then(api => {

          let currentAccount = LocalStorage.getCurrentFisAccount();

          api.tx.rFis
              .liquidityUnbond(selectedPool, amount.toString())
              .signAndSend(currentAccount, { signer: injector.signer }, (result) => {
            
            if (result.status.isInBlock) {
              Indicator.close();
              this.clickBtn = false;

              result.events
                .filter(({ event: { section } }) => section === 'system')
                .forEach(({ event: { data, method } }) => {
                  if (method === 'ExtrinsicFailed') {
                    const [dispatchError] = data
                    if (dispatchError.isModule) {
                      try {
                        const mod = dispatchError.asModule;
                        const error = data.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));

                        let message = 'Something is wrong, please try again later!';
                        if (error.name == 'LiquidityUnbondZero') {
                          message = 'The input amount should be larger than 0';
                        } else if (error.name == 'InsufficientBalance') {
                          message = 'Insufficient balance!';
                        }
                        Toast({ 
                          message: message, 
                          duration: 3000 
                        });
                      } catch (error) {
                        Toast({ 
                          message: error.message, 
                          duration: 3000 
                        });
                      }
                    }
                  } else if (method === 'ExtrinsicSuccess') {
                    Toast({ 
                      message: 'Unbond successfully, you can withdraw your unbonded FIS 14 days later', 
                      duration: 3000 
                    });
                    setTimeout(() => {
                      this.refreshUnbonding();
                      this.clearAfterUnbond();
                    }, 4000);
                  }
                });
            } else if (result.isError) {
              Indicator.close();
              this.clickBtn = false;

              Toast({ 
                message: result.toHuman(), 
                duration: 3000 
              });
            }

          }).catch((error) => {
            Indicator.close();
            this.clickBtn = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });

        })
        .catch((error) => {
          Indicator.close();
          this.clickBtn = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
        
      });
    },

    withdraw() {
      if (this.clickBtn) {
        return;
      }

      if (this.withdrawActiveStatus == 0) {
        return;
      }

      if (this.unbondings.length <= 0) {
        return;
      }

      this.clickBtn = true;

      Indicator.open('Loading...');

      web3Enable(Api.getWeb3EnalbeName());
      web3FromSource(Api.getPolkadotJsSource()).then(injector => {

        Api.createStafiApi().then(api => {

          let currentAccount = LocalStorage.getCurrentFisAccount();

          let txs = [];

          this.unbondings.forEach(unbondingData => {
            unbondingData.unlocks.some(unlock => {
              if (this.currentEra >= unlock.era) {
                txs.push(api.tx.rFis.liquidityWithdrawUnbond(unbondingData.pool));
                return true;
              }
            });
          });

          if (txs.length <= 0) {
            Indicator.close();
            this.clickBtn = false;

            Toast({ 
              message: 'Nothing to withdraw, please try again later!', 
              duration: 3000 
            });
            return;
          }

          api.tx.utility
              .batch(txs)
              .signAndSend(currentAccount, { signer: injector.signer }, (result) => {
            
            if (result.status.isInBlock) {
              Indicator.close();
              this.clickBtn = false;

              result.events
                .filter(({ event: { section } }) => section === 'system')
                .forEach(({ event: { data, method } }) => {
                  if (method === 'ExtrinsicFailed') {
                    const [dispatchError] = data
                    if (dispatchError.isModule) {
                      try {
                        const mod = dispatchError.asModule;
                        const error = data.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));

                        let message = 'Something is wrong, please try again later!';
                        Toast({ 
                          message: message, 
                          duration: 3000 
                        });
                      } catch (error) {
                        Toast({ 
                          message: error.message, 
                          duration: 3000 
                        });
                      }
                    }
                  } else if (method === 'ExtrinsicSuccess') {
                    Toast({ 
                      message: 'Withdraw successfully', 
                      duration: 3000
                    });
                    setTimeout(() => {
                      this.refreshUnbonding();
                      this.$emit('refreshFisBalance');
                    }, 4000);
                  }
                });
            } else if (result.isError) {
              Indicator.close();
              this.clickBtn = false;

              Toast({ 
                message: result.toHuman(), 
                duration: 3000 
              });
            }

          }).catch((error) => {
            Indicator.close();
            this.clickBtn = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });

        })
        .catch((error) => {
          Indicator.close();
          this.clickBtn = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
        
      });
    },

    refreshUnbonding() {
      let currentAccount = LocalStorage.getCurrentFisAccount();

      Api.createStafiApi().then(api => {
        api.query.rBalances.account(0, currentAccount).then(accountData => {
          let data = accountData.toJSON();
          if (data && data.free) {
            this.rTokenAmount = NumberUtil.fisAmountToHuman(data.free);
            this.totalRFIS = NumberUtil.handleFisAmountToFixed(this.rTokenAmount);;
          }
        });

        api.query.rFis.pools().then(poolsData => {
          let pools = poolsData.toJSON();
          if (pools && pools.length > 0) {
            let unbondingToken = 0;
            let withdrawToken = 0;
            let eras = [];

            pools.forEach(pool => {
              api.query.rFis.unbonding(currentAccount, pool).then(unbondingData => {
                let unbondings = unbondingData.toJSON();
                if (unbondings && unbondings.length > 0) {
                  this.unbondings.push({
                    pool: pool,
                    unlocks: unbondings
                  });
                  unbondings.forEach(unbonding => {
                    if (this.currentEra >= unbonding.era) {
                      withdrawToken += Number(unbonding.value);
                    } else {
                      unbondingToken += Number(unbonding.value);
                      eras.push(unbonding.era);
                    }
                  });
                }

                if (eras.length > 0) {
                  let minEra = Math.min.apply(null, eras);
                  this.leftDays = (minEra - this.currentEra) * 6 / 24;
                } else {
                  this.leftDays = '--';
                }

                if (withdrawToken > 0) {
                  this.withdrawActiveStatus = 1;
                } else {
                  this.withdrawActiveStatus = 0;
                }

                this.withdrawToken = NumberUtil.handleFisAmountToFixed(NumberUtil.fisAmountToHuman(withdrawToken));
                this.unbondingToken = NumberUtil.handleFisAmountToFixed(NumberUtil.fisAmountToHuman(unbondingToken));
              });

              let count = 0;
              api.query.staking.ledger(pool).then(ledgerData => {
                count++;
                let ledger = ledgerData.toJSON();
                if (ledger && ledger.active > 0) {
                  this.validPools.push({
                    address: pool,
                    active: ledger.active
                  });
                }
                if (count >= pools.length) {
                  if (this.validPools.length <= 0) {
                    this.warn = true;
                  }
                }
              }).catch((error) => {});

            });
          }
        }).catch((error) => {});

      }).catch((error) => {});
    }


  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.fis-redeem {
  background-color: #2B3239;
  width: 683px;
  height: 535px;
  border-radius: 19px;
  padding: 0 20px;

  .redeem-header {
    display: flex;
    margin-left: 43px;
    margin-bottom: 30px;

    .arrow-icon {
      cursor: pointer;
      margin-top: 40px;
      margin-right: 20px;
      height: 23px;
      img {
        height: 100%;
      }
    }
    
    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 35px;
    }
  }

  .redeem-content {
    margin-left: 77px;
    margin-right: 120px;
  }

  .warn {
    margin-top: 20px;
    color: #FD5D89;
  }

  .inputs-amount {
    margin-top: 8px;
    height: 50px;
    border-radius: 3.65px;
    border: 1px solid #BFBFBF;
    padding-left: 25px;
    position: relative;
    
    .icon {
      height: 36px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      img {
        height: 100%;
      }
    }
    input {
      font-size: 22px;
      font-weight: bold;
      width: 390px;
      height: 48px;
      background-color: #2B3239;
      border: 0;
      color: #fff;

      &:focus {
        outline: none
      }
    }
  }

  .warn-title {
    margin-top: 20px;
  }

  .rfis-balance {
    margin-top: 8px;
    text-align: right;
    color: #C4C4C4;
    font-size: 12px;
  }

  .get-fis {
    margin-top: 8px;
    text-align: right;
    color: #C4C4C4;
    font-size: 12px;
  }

  .operation {
    margin-top: 20px;
    display: flex;
  }

  .unbond-desc {
    color: #C4C4C4;
    font-size: 12px;
    height: 28px;
    line-height: 28px;
    margin-left: 10px;
  }

  .unbond-btn {
    cursor: pointer;
    width: 69px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    opacity: 0.4;
    border-radius: 13px;
    text-align: center;
  }

  .withdraw-btn {
    cursor: pointer;
    width: 69px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #23292F;
    font-weight: bold;
    background-color: #00F3AB;
    opacity: 0.4;
    border-radius: 13px;
    text-align: center;
  }

  .btn-active {
    opacity: 1;
  }

  .withdraw {
    margin-top: 60px;

    .withdraw-content {
      margin-top: 20px;
      margin-bottom: 30px;
    }

    .withdraw-token {
      color: #00F3AB;
      font-size: 30px;
      font-weight: bold;
    }

    .unbonding-token {
      margin-left: 20px;
      font-size: 12px;
    }

    .ubonding-amount {
      font-weight: bold;
    }
  }

}
</style>
